import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import "./Modal.scss"
import ReactDOM from 'react-dom';

function Modal({ selectedImage, SetSelectedImage, showDetails }) {
  const [isClicked, setIsClicked] = useState(true);

  const handleClick = (e) => {
    if (e.target.classList.contains('backdrop')) {
      setIsClicked(false);
    }
  };

  const handleExitComplete = () => {
    if (!isClicked) {
      SetSelectedImage(null);
    }
  };

  const handleContextMenu = (e) => {
    e.preventDefault(); // Prevent the default context menu behavior
  };


  return ReactDOM.createPortal(
    <>
      <div>
        <AnimatePresence onExitComplete={handleExitComplete}>
          {isClicked && (
            <motion.div
              className="backdrop"
              onClick={handleClick}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              {/* Conditionally render the background only if details exist */}
              {(showDetails && selectedImage.Client && selectedImage.Duration && selectedImage.Background) ? (
                <div className='backwhite'>
                  {(() => {
                    try {
                      if (selectedImage.Label === 'Video') {
                        // Display video if Label is 'video'
                        return (
                          <motion.video
                            controls
                            src={selectedImage.PhotoUrl}
                            className='ModImg'
                            type="video/mp4"
                            key={selectedImage.PhotoUrl}
                            onContextMenu={handleContextMenu}
                            initial={{ y: '-50vh' }}
                            animate={{ y: 0 }}
                            exit={{ y: '50vh' }}
                            height="90%"
                            autoPlay
                            loop
                          />
                        );
                      } else {
                        // Display image for other cases
                        return (
                          <motion.img
                            className='ModImg'
                            src={selectedImage.PhotoUrl}
                            onContextMenu={handleContextMenu}
                            alt="Full view"
                            key={1}
                            initial={{ y: '-100vh' }}
                            animate={{ y: 0 }}
                            exit={{ y: '100vh' }}
                          />
                        );
                      }
                    } catch (error) {
                      // Handle the error gracefully
                      console.error('Error:', error);
                      // Render a fallback or error message
                      return <p>Error: Failed to render data</p>;
                    }
                  })()}
                  <div className="textual">
                    {showDetails && selectedImage.Client && selectedImage.Duration && selectedImage.Background && selectedImage.Objective && selectedImage.Challenges && selectedImage.Solutions && selectedImage.Results && (
                      <motion.div className="details"
                        key={2}
                        initial={{ y: '-100vh' }}
                        animate={{ y: 0 }}
                        exit={{ y: '100vh' }}
                      >

                        {/* Add your details here */}
                        <h2>Case Study: {selectedImage.Title}</h2>
                        <p>{selectedImage.Detail}</p>
                        <p><strong>Project Date: {selectedImage.Year}</strong></p>
                        <p className='slanty'>-{selectedImage.Label} Design</p>
                        <p><strong>Client:</strong> {selectedImage.Client}</p>
                        <p><strong>Client Background:</strong> {selectedImage.Background}</p>
                        <p><strong>Objective:</strong> {selectedImage.Objective}</p>
                        <p><strong>Challenges:</strong> {selectedImage.Challenges}</p>
                        <p><strong>Solutions:</strong> {selectedImage.Solutions}</p>
                        <p><strong>Results:</strong> {selectedImage.Results}</p>

                        <div className="FullProj">
                          <Link to={`/fullProject/${selectedImage.id}`}>View Full Project</Link>
                        </div>
                        {/* Add other details as needed */}
                      </motion.div>
                    )}
                  </div>

                </div>
              ) : (

                // Display video or image without background if no details exist
                selectedImage.Label === 'Video' ? (
                  <motion.video
                    controls
                    src={selectedImage.PhotoUrl}
                    className='ModImg half-size'
                    type="video/mp4"
                    key={selectedImage.PhotoUrl}
                    onContextMenu={handleContextMenu}
                    initial={{ y: '-50vh' }}
                    animate={{ y: 0 }}
                    exit={{ y: '50vh' }}
                    height="90%"
                    autoPlay
                    loop
                  />
                ) : (
                  <motion.img
                    className='ModImg half-size'
                    src={selectedImage.PhotoUrl}
                    onContextMenu={handleContextMenu}
                    alt="Full view"
                    key={1}
                    initial={{ y: '-100vh' }}
                    animate={{ y: 0 }}
                    exit={{ y: '100vh' }}
                  />
                )
              )}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>,
    document.getElementById('portal')
  );
}

export default Modal;
